import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';

export function* forwardVoicemailSaga(action) {
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);
        const voicemail = action.payload;

        // API endpoint for retrieving voicemail (relative URL)
        const apiUrl = '?object=audio&action=update';
        // Parameters for the API call
        const params = {
            format: 'json',
            owner: user,
            owner_domain: domain,
            type: voicemail.vmail_type,
            index: voicemail.filename,
            intArray: 'true',
            forward: voicemail.forwardTo,
        };
        const response = yield call(cirrusClient.get, apiUrl, { params });
        if (response.status === 202) {
            yield put(showSnackbar({
                message: `Forwarded the Voicemail`,
                severity: 'success'
            }));
        }
    }
    catch (error) {
        console.error(error);
        yield put(showSnackbar({
            message: `Error Forwarding Voicemail`,
            severity: 'error'
        }));

    }
}